// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box_top_popClass {\n  font-size: 12px;\n  padding: 12px 16px;\n  justify-content: space-between;\n}\n.contactPopper {\n  max-height: 400px;\n  overflow-y: auto;\n  padding: 0;\n}\n", ""]);
// Exports
module.exports = exports;
